import type { GeoItem } from '~/common/types';

/** Keep only geo-items matching the org's mobile report type (pothole log vs manhole inspection). */
export function filterGeoItemsByReportType(items: readonly GeoItem[], mobileReportType?: string): GeoItem[] {
  const targetType = mobileReportType === 'manholeInspection' ? 'manholeInspection' : 'potholeLog';
  return items.filter(({ type }) => type === targetType);
}
